(function(){
 'use strict';
 function boot(){
  var header=document.querySelector('[data-tll-store-header]');if(!header||header.dataset.initialized)return;
  header.dataset.initialized='true';var panels=Array.from(header.querySelectorAll('[data-header-panel]'));
  panels.forEach(function(panel){panel.addEventListener('toggle',function(){if(panel.open)panels.forEach(function(other){if(other!==panel)other.open=false;});});});
  header.querySelectorAll('[data-header-close]').forEach(function(b){b.addEventListener('click',function(){var panel=b.closest('[data-header-panel]');if(panel){panel.open=false;panel.querySelector('summary').focus();}});});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')panels.forEach(function(p){if(p.open){p.open=false;p.querySelector('summary').focus();}});});
  document.addEventListener('click',function(e){if(!header.contains(e.target))panels.forEach(function(p){p.open=false;});});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
 document.addEventListener('shopify:section:load',boot);
})();
